module.exports = __webpack_public_path__ + "img/trackd-icon-dark.59aefd6b.svg";